import { useState } from "react";
import "./Login.css";
import { useNavigate, Link } from "react-router-dom"; // Link es mejor que <a>
import logo from "../../Imagenes/logoMundo_shop.jpeg";
const API = process.env.REACT_APP_API_URL

console.log("Mi API está en:", API);

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // Estado para el botón

  const enviarDatos = async (e) => {
    e.preventDefault();
    setLoading(true);

    const datos = { username, password };

    try {
      const response = await fetch( API + "/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify(datos),
        credentials: "include"
      });

      const data = await response.json();

      if (data.accessToken) {
        localStorage.setItem("token", data.accessToken);
        localStorage.setItem(
          "user",
          JSON.stringify({ rol: data.roles[0].authority, id: data.userId , refreshToken: data.refreshToken })
        );
        navigate("/"); 
      } else {
        alert("Usuario o contraseña incorrectos");
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      alert("Ocurrió un error, intenta de nuevo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* Logo con link al inicio */}
        <Link to="/" className="login-logo-link">
          <img src={logo} alt="Mundo Shop" className="login-logo" />
        </Link>

        <h2 className="login-title">¡Bienvenido de nuevo!</h2>
        <p className="login-subtitle">
          Ingresa tus credenciales para acceder a <strong>Mundo Shop</strong>
        </p>

        <form className="login-form" onSubmit={enviarDatos}>
          <div className="input-group">
            <label htmlFor="username">Usuario o Correo</label>
            <input
              id="username"
              type="text"
              placeholder="Ej: juanito123"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Verificando..." : "Iniciar Sesión"}
          </button>
        </form>

        <div className="login-actions">
          <Link to="/olvidé" className="forgot-password">¿Olvidaste tu contraseña?</Link>
          <div className="divider"></div>
          <p className="register-text">
            ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
          </p>
        </div>
      </div>
    </div>
  );
}